import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon } from 'lucide-react';
import { handbooks } from '../data/offer';
export function VisualHandbooks() {
  return <section className="bg-acad-canvas px-4 py-20 sm:py-28" data-id="element-227" data-mp="1e504bzgntisf">
      <div className="mx-auto max-w-6xl" data-id="element-228" data-mp="1e5i95khe15by">
        <div className="mx-auto max-w-3xl text-center" data-id="element-229" data-mp="1j3tjrxfibjv8">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-acad-gold" data-id="element-230" data-mp="1j3jp3wjiooj7">
            And that is only the core library
          </p>
          <h2 className="mt-3 font-display text-4xl font-semibold text-acad-ink sm:text-5xl" data-id="element-231" data-mp="qf5qpfoinq74">
            You Also Receive 3 Professional Visual Handbooks
          </h2>
          <p className="mt-4 text-base leading-7 text-acad-muted" data-id="element-232" data-mp="vglg1jxq8ivb">
            Some concepts are easier to teach when you can see the structure
            immediately. These three visual resources are built for fast
            reference before or during your teaching week.
          </p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-233" data-mp="2bulbahlmnkc8">
          {handbooks.map((handbook, index) => <motion.article key={handbook.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.28,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex h-full flex-col rounded-2xl border border-acad-line bg-white p-6 shadow-card sm:p-7" data-id="element-234" data-mp="1zh9s4krd0ppg" data-mpi={index}>
              <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-acad-gold/50 bg-acad-goldSoft text-acad-goldDark" data-id="element-235" data-mp="17qwp0dksq354">
                <BookOpenIcon size={22} aria-hidden="true" data-id="element-236" data-mp="12sv4do7q1vrj" />
              </span>
              <p className="mt-5 text-xs font-bold uppercase tracking-[0.14em] text-acad-gold" data-id="element-237" data-mp="xspiyps1p5hw">
                {handbook.id}
              </p>
              <h3 className="mt-2 font-display text-2xl font-semibold leading-tight text-acad-ink" data-id="element-238" data-mp="t34vvw1u79f4">
                {handbook.title}
              </h3>
              <p className="mt-4 text-sm leading-6 text-acad-muted" data-id="element-239" data-mp="e7yrfdie3inw">
                {handbook.description}
              </p>
              <p className="mt-auto pt-5 text-sm font-semibold italic text-acad-goldDark" data-id="element-240" data-mp="j71vaummviua">
                {handbook.usage}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}